<template>
<Dialog v-model="visible" setting @setting="$emit('setting')">

  <template slot="title">
    <span class="title">{{$t('light.control')}}</span>
  </template>

  <v-col v-if="!colorSetting" align="center" class="mb-5 pb-5">
    <v-icon size="120" :color="power ? 'primary' : 'grey'">{{ power ? 'mdi-lightbulb' : 'mdi-lightbulb-off' }}</v-icon>
  </v-col>

  <v-slider v-if="!colorSetting" v-model="brightnessInner" min="0" max="100" thumb-label="always" track-color="grey" track-fill-color="primary" class="mx-5 pt-5"></v-slider>

  <v-col v-if="colorSetting" align="center" class="py-4">
    <WheelColorPicker v-model="colorInner"></WheelColorPicker>
  </v-col>

  <template slot="actions">
    <v-btn outlined color="secondary" @click="powerInner=false">{{ $t('light.off') }}</v-btn>
    <v-spacer></v-spacer>
    <v-btn outlined color="primary" @click="powerInner=true">{{ $t('light.on') }}</v-btn>
  </template>

</Dialog>
</template>

<script>
import BaseDialog from '@/components/utils/dialog/BaseDialog'
import Dialog from '@/components/utils/dialog/Dialog'
import WheelColorPicker from '@/components/utils/WheelColorPicker'

let delayHandler;

export default {
  name: 'LightControlDialog',
  mixins: [BaseDialog],
  components: {
    Dialog,
    WheelColorPicker
  },
  props: {
    power: {
      type: Boolean,
      default: false
    },
    brightness: {
      type: Number,
      default: 0
    },
    color: {
      type: Object
    },
    colorSetting: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    powerInner: {
      get() {
        return this.power;
      },
      set(val) {
        this.$emit('update:power', val);
      }
    },
    brightnessInner: {
      get() {
        return this.brightness;
      },
      set(val) {
        if (delayHandler) clearTimeout(delayHandler);
        delayHandler = setTimeout(() => {
          this.$emit('update:brightness', val);
        }, 500);
      }
    },
    colorInner: {
      get() {
        return this.color;
      },
      set(val) {
        if (delayHandler) clearTimeout(delayHandler);
        delayHandler = setTimeout(() => {
          this.$emit('update:color', val);
          this.$emit('update:brightness', val.v);
        }, 500);
      }
    }
  }
}
</script>
